<template>
  <div>
    <div class="loading" v-if="weekend === null || courses === null">
      <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div v-else>
      <md-toolbar class="md-dense" md-elevation="1" style="background-color: #FFFFFF">
        <div class="md-toolbar-section-start">
          <md-button class="md-icon-button md-dense" style="margin-right: 0px"
                     v-bind:class="{'md-primary': slotDurationIndex === 0, 'md-raised': slotDurationIndex === 0}"
                     @click="setSlotDuration(0)">10
          </md-button>
          <md-button class="md-icon-button md-dense"
                     v-bind:class="{'md-primary': slotDurationIndex === 1, 'md-raised': slotDurationIndex === 1}"
                     @click="setSlotDuration(1)">15</md-button>
          <md-button class="md-icon-button md-dense"
                     v-bind:class="{'md-primary': slotDurationIndex === 2, 'md-raised': slotDurationIndex === 2}"
                     @click="setSlotDuration(2)">30</md-button>
          <md-button class="md-icon-button md-dense" @click="$refs.calendar.fireMethod('prev')" v-if="currentView === 'agendaDay'">
            <md-icon>keyboard_arrow_left</md-icon>
          </md-button>
          <md-button class="md-icon-button md-dense" @click="$refs.calendar.fireMethod('next')" v-if="currentView === 'agendaDay'">
            <md-icon>keyboard_arrow_right</md-icon>
          </md-button>
        </div>
        <h3 class="md-title">{{weekend.name}}<span v-if="currentView === 'agendaDay' || true"><br/><small>{{currentViewTitle}}</small></span></h3>
        <div class="md-toolbar-section-end">
          <md-button v-if="activityRevertCommand" class="md-icon-button" @click="revertActivity">
            <md-icon>undo</md-icon>
            <md-tooltip v-if="activityRevertCommand.method === 'moveActivity'" md-delay="1000">Undo Move</md-tooltip>
            <md-tooltip v-if="activityRevertCommand.method === 'deleteActivity'" md-delay="1000">Undo Delete
            </md-tooltip>
            <md-tooltip v-if="activityRevertCommand.method === 'saveActivity'" md-delay="1000">Undo Save</md-tooltip>
          </md-button>
          <md-menu v-if="usedStaffList.length > 0" md-size="small" md-align-trigger :md-close-on-select="1===0">
            <md-button class="md-icon-button" md-menu-trigger>
              <md-icon v-bind:class="{'md-accent': selectedStaffForFilter.length > 0}">face</md-icon>
            </md-button>

            <md-menu-content>
              <span :key="staff.versionedId.id" v-for="staff in usedStaffList">
              <md-list-item style="display: inline-block;">
                <md-switch :value="staff.versionedId.id" v-model="selectedStaffForFilter"></md-switch>
                <span class="md-list-item-text">{{staff.name}}</span>
              </md-list-item>
              <md-button @click="promptToDeleteUser(staff)" class="md-icon-button" style="float: right">
                <md-icon>delete_forever</md-icon>
              </md-button>
              </span>

            </md-menu-content>
          </md-menu>

          <md-menu v-if="usedLocationList.length > 0" md-size="small" md-align-trigger>
            <md-button class="md-icon-button" md-menu-trigger>
              <md-icon v-bind:class="{'md-accent': selectedLocationsForFilter.length > 0}">room</md-icon>
            </md-button>

            <md-menu-content>
              <md-menu-item v-for="location in usedLocationList" :key="location.versionedId.id">
                <md-switch v-model="selectedLocationsForFilter" :value="location.versionedId.id"></md-switch>{{location.name}}
              </md-menu-item>
            </md-menu-content>
          </md-menu>

          <md-button class="md-icon-button" v-bind:class="{'md-primary': currentView === 'agendaDay', 'md-raised': currentView === 'agendaDay'}" @click="$refs.calendar.fireMethod('changeView', 'agendaDay')">
            <md-icon>view_day</md-icon>
          </md-button>
          <md-button class="md-icon-button" v-bind:class="{'md-primary': currentView === 'weekend', 'md-raised': currentView === 'weekend'}" @click="$refs.calendar.fireMethod('changeView', 'weekend', weekend.start)">
            <md-icon>view_week</md-icon>
          </md-button>
          <md-button class="md-icon-button"
                     v-bind:class="{'md-primary': currentView === 'links', 'md-raised': currentView === 'links'}"
                     :to="'../weekendReports/' + weekend.versionedId.id">
            <md-icon>link</md-icon>
          </md-button>
          <md-button class="md-icon-button"
                     :href="'/api/zip/' + weekend.versionedId.id + '/' + weekend.name.toLowerCase().split(' ').join('_') + '.zip'">
            <md-icon>picture_as_pdf</md-icon>
          </md-button>
          <md-button class="md-icon-button" @click="editWeekend">
            <md-icon>edit</md-icon>
          </md-button>
        </div>
      </md-toolbar>
      <br/>

      <md-content class="md-elevation-1">
        <full-calendar ref="calendar" :events="calendarEvents" :config="calendarConfig"
                       @event-created="createEventFromSelect"
                       @event-resize="moveEventFromSelect"
                       @event-drop="moveEventFromSelect"
                       @event-selected="editEventFromSelect"
                       style="background-color: #FFFFFF"
        />
      </md-content>

      <!--This is needed to make sure that the unsatisified course activities show up on the first load. I'm not sure why.-->
      <span v-if="unsatisifiedCourseActivities" style="display:none">{{unsatisifiedCourseActivities.length}}</span>

      <br/>
      <md-content v-if="currentView !== 'listWeekend' && unsatisifiedCourseActivities && unsatisifiedCourseActivities.length > 0"
                  v-bind:class="{'scrolledUp': !showMissingCourseActivities}"
                  class="md-elevation-1" style="padding: 2px">
        <md-button v-if="showMissingCourseActivities" class="md-icon-button md-dense" @click="showMissingCourseActivities = false">
          <md-icon>expand_less</md-icon>
        </md-button>
        <md-button v-if="!showMissingCourseActivities" class="md-icon-button md-dense" @click="showMissingCourseActivities = true">
          <md-icon>expand_more</md-icon>
        </md-button>
        <div v-for="course in unsatisifiedCourseActivities" :key="course.courseId">
          <div class="md-layout md-alignment-center-left">
            <div>
              <strong>{{course.courseName}}</strong>
            </div>
            <div class="draggable md-layout-item" draggable="true" v-for="template in course.activities" :key="template.activity.versionedId.id"
                 :data-duration=" Math.floor(template.activity.length / 60) + ':' + (template.activity.length % 60)"
                 :data-event="JSON.stringify({'title':template.activity.name, 'stick': false, 'courseActivityId':template.activity.versionedId.id, 'description':template.activity.description})"
                 :style="'background-color: ' + course.color"
            >
              <div v-for="section in template.sections"
                   style="padding-left: 1px; padding-right: 1px; display: inline-block;">
                <small>{{section.abbreviation}}</small>
              </div>
              <br/>
              {{template.activity.name}}
            </div>
          </div>
        </div>
      </md-content>

      <md-dialog :md-active.sync="linksDialogActive">
        <md-dialog-title>Read Only Links</md-dialog-title>
        <a target="_blank" :href="'/static/view/master/#' + weekend.versionedId.id">Master Schedule</a>
        <br/>
        <br/>
        <md-dialog-content>
          <div class="md-subheading">Sections</div>
          <div v-for="section in this.weekend.sections" :key="section.versionedId.id">
            <a :href="'/static/view/#' + weekend.versionedId.id + '/t/' + section.versionedId.id">{{section.name}}</a>
          </div>
          <br/>
          <div v-if="usedStaffList && usedStaffList.length > 0">
            <div class="md-subheading">Staff</div>
            <div v-for="staff in usedStaffList" :key="staff.versionedId.id">
              <a :href="'/static/view/#' + weekend.versionedId.id + '/s/' + staff.versionedId.id">{{staff.name}}</a>
            </div>
            <br/>
          </div>
          <div v-if="usedLocationList && usedLocationList.length > 0">
            <div class="md-subheading">Locations</div>
            <div v-for="location in usedLocationList" :key="location.versionedId.id">
              <a
                :href="'/static/view/#' + weekend.versionedId.id + '/l/' + location.versionedId.id">{{location.name}}</a>
            </div>
          </div>
        </md-dialog-content>
      </md-dialog>

      <md-dialog :md-active.sync="weekendDetailsDialogActive">
        <md-dialog-title>Edit Weekend</md-dialog-title>

        <md-tabs>
          <md-tab md-label="Overview">
            <md-field>
              <label>Name</label>
              <md-input v-focus ref="weekendDetailsDialogFirstField" v-model="dialogWeekend.name" maxlength="255"></md-input>
            </md-field>
            <md-field>
              <md-icon>access_time</md-icon>
              <label>Daily Start Time</label>
              <md-input v-model="dialogWeekend.dailyStart" type="time" step="60"/>
            </md-field>
            <md-field>
              <md-icon>access_time</md-icon>
              <label>Daily End Time</label>
              <md-input v-model="dialogWeekend.dailyEnd" type="time" step="60"/>
            </md-field>
          </md-tab>

          <md-tab md-label="Details">
            <md-field>
              <label>Start Date</label>
              <md-select v-model="dialogWeekend.start">
                <md-option :value="addDays(dialogWeekend.oldStart, -1)">{{addDays(dialogWeekend.oldStart, -1)}}</md-option>
                <md-option :value="dialogWeekend.oldStart">{{dialogWeekend.oldStart}}</md-option>
                <md-option :value="addDays(dialogWeekend.oldStart, 1)">{{addDays(dialogWeekend.oldStart, 1)}}</md-option>
              </md-select>
            </md-field>
            <md-field>
              <label>End Date</label>
              <md-select v-model="dialogWeekend.end">
                <md-option :value="addDays(dialogWeekend.oldEnd, -1)">{{addDays(dialogWeekend.oldEnd, -1)}}</md-option>
                <md-option :value="dialogWeekend.oldEnd">{{dialogWeekend.oldEnd}}</md-option>
                <md-option :value="addDays(dialogWeekend.oldEnd, 1)">{{addDays(dialogWeekend.oldEnd, 1)}}</md-option>
              </md-select>
            </md-field>
          </md-tab>
          <md-tab md-label="Add Sections">
            <div style="text-align: center;">
              <md-button class="md-icon-button md-raised md-primary" @click="addSectionToDialogWeekend">
              <!--<md-button class="md-icon-button md-raised md-primary">-->
                <md-icon>add</md-icon>
              </md-button>
            </div>
            <div style="height: 300px; overflow: auto; overflow-x: hidden">
              <table v-if="dialogWeekend.newSections && dialogWeekend.newSections.length > 0" width="100%"
                     style="text-align: center">
                <tr style="font-size: 16px;">
                  <th>Name</th>
                  <th>Course</th>
                  <th>Max Students</th>
                  <th>Current Students</th>
                </tr>
                <tr v-for="(section, index) in dialogWeekend.newSections">
                  <td>
                    <md-field>
                      <md-input v-model="section.name"></md-input>
                    </md-field>
                  </td>
                  <td>
                    <md-field>
                      <md-select v-model="section.courseId" v-bind:disabled="weekend.courseIds.length === 0" md-dense>
                        <md-option value="">None</md-option>
                        <md-option v-for="courseId in weekend.courseIds" :value="courseId.id" :key="courseId.id">
                          {{getCourse(courseId.id).name}}
                        </md-option>
                      </md-select>
                    </md-field>
                  </td>
                  <td>
                    <md-field>
                      <md-input v-model="section.maxStudents" type="number"></md-input>
                    </md-field>
                  </td>
                  <td>
                    <md-field>
                      <md-input v-model="section.currentStudents" type="number"></md-input>
                    </md-field>
                  </td>
                  <td>
                    <md-button class="md-icon-button md-dense md-primary"
                               @click="dialogWeekend.newSections.splice(index,1)">
                      <md-icon class="md-morph-final">delete</md-icon>
                    </md-button>
                  </td>
                </tr>
              </table>
            </div>
          </md-tab>

          <md-tab md-label="Notes">
            <md-field>
              <label>Staff Notes</label>
              <md-textarea v-model="dialogWeekend.staffNotes"></md-textarea>
            </md-field>

            <md-field>
              <label>Student Notes</label>
              <md-textarea v-model="dialogWeekend.studentNotes"></md-textarea>
            </md-field>
          </md-tab>
        </md-tabs>
        <div class="md-layout">
          <div class="md-layout-item md-layout md-alignment-bottom-space-between">
            <div>
              <md-button v-if="!dialogActivity.isNew" class="md-primary" @click="deleteWeekendPromptActive = true; weekendDetailsDialogActive = false">Delete</md-button>
            </div>
            <div>
              <md-button class="md-primary" @click="weekendDetailsDialogActive = false">Cancel</md-button>
              <md-button class="md-primary md-raised" @click="saveWeekend" v-bind:disabled="!weekendDetailsDialogCreateSaveActive">Save</md-button>
            </div>
          </div>
        </div>
      </md-dialog>

      <md-dialog-confirm
        :md-active.sync="deleteWeekendPromptActive"
        md-title="Delete Weekend"
        :md-content="'Are you sure you want to delete \'' + weekend.name + '\'?'"
        md-confirm-text="Delete"
        md-cancel-text="Cancel"
        @md-confirm="deleteWeekend" />

      <md-dialog-confirm
        :md-active.sync="deleteSectionPromptActive"
        md-title="Delete Section"
        :md-content="'Are you sure you want to delete \'' + sectionToDelete.name + '\' and all activities only associated with this section?'"
        md-confirm-text="Delete"
        md-cancel-text="Cancel"
        @md-confirm="deleteSection" />

      <md-dialog-confirm
        :md-active.sync="deleteStaffPromptActive"
        :md-content="'Are you sure you want to remove \'' + staffToDelete.name + '\' from all activities?<br/>This action might take a minute to complete and can\'t be undone.'"
        @md-confirm="deleteStaff"
        md-cancel-text="Cancel"
        md-confirm-text="Delete"
        md-title="Delete Staff"/>

      <md-dialog :md-active.sync="sectionDetailsDialogActive">
        <md-dialog-title>Section {{dialogSection.name}}</md-dialog-title>

        <md-tabs :md-active-tab="dialogSection.tab">
          <md-tab md-label="Details" id="details">
            <md-field>
              <label>Name</label>
              <md-input v-model="dialogSection.name" maxlength="255"></md-input>
            </md-field>
            <md-field>
              <label>Course</label>
              <md-select v-model="dialogSection.courseId" v-bind:disabled="weekend.courseIds.length === 0" md-dense>
                <md-option value="">None</md-option>
                <md-option v-for="courseId in weekend.courseIds" :value="courseId.id" :key="courseId.id">{{getCourse(courseId.id).name}}</md-option>
              </md-select>
            </md-field>
            <md-field>
              <label>Max Students</label>
              <md-input v-model="dialogSection.maxStudents" type="number"></md-input>
            </md-field>            <md-field>
            <label>Current Students</label>
            <md-input v-model="dialogSection.currentStudents" type="number"></md-input>
          </md-field>
          </md-tab>

          <md-tab md-label="Staff" id="staff">
            <span v-for="day in weekendDays" :key="day">
              <div style="border: 1px solid lightgray; border-radius: 3px; margin: 8px; padding: 4px;">
                <strong>{{day}}</strong><br/>
                <md-chip v-for="(staffId, i) in dialogSection.staffIds[day]" :key="staffId"  v-bind:class="{'md-accent': i === 0}"
                         @md-delete="deleteStaffIdFromDialog(dialogSection.staffIds[day], staffId)"
                         @click="setPrimaryStaffIdFromDialog(dialogSection.staffIds[day], staffId)"
                         md-deletable md-clickable md-accent>
                  {{getStaffCardString(staffId)}}
                </md-chip>
                <br/>

                <select @change="addStaffIdFromDialog(dialogSection.staffIds, day, dialogSection.newStaffId, day)"
                        v-if="dialogSection.newStaffId[day] !== null" v-model="dialogSection.newStaffId[day]">
                  <option :value="staff" v-for="staff in enabledStaffList">{{staff.visibleName}}</option>
                </select>
                <!--<md-autocomplete v-if="dialogSection.newStaffId[day] !== null" v-model="dialogSection.newStaffId[day]"-->
                <!--:md-options="enabledStaffList"-->
                <!--:md-selected="addStaffIdFromDialog(dialogSection.staffIds, day, dialogSection.newStaffId, day)"-->
                <!--md-dense style="margin-bottom: 0px;">-->
                <!--<label>Add staff</label>-->

                <!--<template slot="md-autocomplete-item" slot-scope="{ item, term }">-->
                <!--<md-highlight-text :md-term="term">{{ item.visibleName }}</md-highlight-text>-->
                <!--</template>-->

                <!--<template slot="md-autocomplete-empty" slot-scope="{ term }">-->
                <!--No staff matching "{{ term }}" were found. <a @click="showNewStaffDialog(term)">Create a new</a> one!-->
                <!--</template>-->
                <!--</md-autocomplete>-->
              </div>
            </span>

          </md-tab>
          <md-tab md-label="Notes">
            <md-field>
              <label>Staff Notes</label>
              <md-textarea v-model="dialogSection.staffNotes"></md-textarea>
            </md-field>

            <md-field>
              <label>Student Notes</label>
              <md-textarea v-model="dialogSection.studentNotes"></md-textarea>
            </md-field>
          </md-tab>
        </md-tabs>
        <div class="md-layout">
          <div class="md-layout-item md-layout md-alignment-bottom-space-between">
            <div>
              <md-button class="md-primary" @click="sectionToDelete = dialogSection; deleteSectionPromptActive = true; sectionDetailsDialogActive = false;">Delete</md-button>
            </div>
            <div>
              <md-button class="md-primary" @click="sectionDetailsDialogActive = false">Cancel</md-button>
              <md-button class="md-primary md-raised" @click="saveSection" v-bind:disabled="!sectionDetailsDialogCreateSaveActive">Save</md-button>
            </div>
          </div>
        </div>
        <md-dialog-actions>
        </md-dialog-actions>
      </md-dialog>

      <md-dialog :md-active.sync="activityDetailsDialogActive" @md-closed="cancelActivityDetailsDialog();">
        <div class="dialogContent">
          <md-tabs>
            <md-tab md-label="Overview">
              <md-field>
                <label>Name</label>
                <md-input v-focus ref="activityDetailsDialogFirstField" v-model="dialogActivity.name" @keyup.esc="cancelActivityDetailsDialog" @keyup.enter="saveOrCreateActivity" maxlength="255"></md-input>
              </md-field>

              <md-field>
                <label>Description</label>
                <md-input v-model="dialogActivity.description" @keyup.esc="cancelActivityDetailsDialog" @keyup.enter="saveOrCreateActivity" maxlength="255"></md-input>
              </md-field>

              <!--<label>Section</label>-->
              Section<br/>
              <md-checkbox v-model="dialogActivity.sectionIds" v-for="section in this.weekend.sections" :key="section.versionedId.id"  :value="section.versionedId.id">{{section.name}} ({{section.maxStudents}} s)</md-checkbox>

              <md-field>
                <label>Location</label>
                <md-select v-model="dialogActivity.locationId" md-dense>
                  <md-option value="">None</md-option>
                  <md-option v-for="location in locationList" :key="location.versionedId.id"  :value="location.versionedId.id">{{location.name}} ({{location.capacity}} s)</md-option>
                </md-select>
              </md-field>
              <div style="border: 1px solid lightgray; border-radius: 3px; padding: 4px;">
                <md-chip v-for="(staffAssignment, i) in dialogActivity.staffAssignments" :key="staffAssignment.staffId"
                         v-bind:class="{'md-accent': i === 0}"
                         @click="staffAssignment.menu = true"
                         md-clickable md-accent>

                  <md-menu md-size="small" md-direction="bottom-start" :md-active.sync="staffAssignment.menu"
                           md-align-trigger>
                    {{getStaffCardString(staffAssignment.staffId)}}
                    <small v-if="staffAssignment.label && staffAssignment.label.length > 0">
                      ({{staffAssignment.label}})
                    </small>

                    <md-menu-content>
                      <md-list class="md-dense">
                        <md-list-item>
                          <md-icon>person</md-icon>
                          <span class="md-list-item-text">{{getStaffNameString(staffAssignment.staffId)}}</span>
                        </md-list-item>
                        <md-list-item v-if="i !== 0"
                                      @click="setPrimaryStaffIdFromDialog(dialogActivity.staffAssignments, staffAssignment); staffAssignment.menu = false">
                          <md-icon>publish</md-icon>
                          <span class="md-list-item-text">Make Primary</span>
                        </md-list-item>

                        <md-list-item :key="label.label"
                                      @click="staffAssignment.label = label.label; if(label.label === 'Lead' || label.label === 'Teach')setPrimaryStaffIdFromDialog(dialogActivity.staffAssignments, staffAssignment); staffAssignment.menu = false"
                                      v-for="label in staffLabels">
                          <md-icon>{{label.icon}}</md-icon>
                          <span class="md-list-item-text">{{label.label}}</span>
                        </md-list-item>

                        <md-list-item
                          @click="deleteStaffIdFromDialog(dialogActivity.staffAssignments, staffAssignment); filterLabels(dialogActivity.staffAssignments); staffAssignment.menu = false">
                          <md-icon>delete</md-icon>
                          <span class="md-list-item-text">Delete</span>
                        </md-list-item>

                      </md-list>
                    </md-menu-content>
                  </md-menu>

                </md-chip>
                <br/>
                <select
                  @change="addStaffIdToActivityFromDialog(dialogActivity, 'staffAssignments', dialogActivity, 'newStaffId')"
                  v-if="this.dialogActivity.newStaffId !== null" v-model="dialogActivity.newStaffId">
                  <option value="addstaff">Add Staff</option>
                  <option :value="staff" v-for="staff in enabledStaffList">{{staff.visibleName}}</option>
                </select>
                <!--<md-autocomplete v-if="this.dialogActivity.newStaffId !== null" v-model="dialogActivity.newStaffId"-->
                <!--:md-options="enabledStaffList"-->
                <!--@md-selected="addStaffIdToActivityFromDialog(dialogActivity, 'staffAssignments', dialogActivity, 'newStaffId')"-->
                <!--md-dense style="margin-bottom: 0px;">-->
                <!--<label>Add staff</label>-->

                <!--<template slot="md-autocomplete-item" slot-scope="{ item, term }">-->
                <!--<md-highlight-text :md-term="term">{{ item.visibleName }}</md-highlight-text>-->
                <!--</template>-->

                <!--<template slot="md-autocomplete-empty" slot-scope="{ term }">-->
                <!--No staff matching "{{ term }}" were found. <a @click="showNewStaffDialog(term)">Create a new</a> one!-->
                <!--</template>-->
                <!--</md-autocomplete>-->
              </div>

              <div v-for="conflict in dialogActivity.conflicts">
                <strong>{{conflict.title}}</strong><br/>
                {{conflict.description}}
              </div>
              <md-checkbox v-model="dialogActivity.allStaff">All Staff</md-checkbox>
              <md-checkbox v-model="dialogActivity.ignoreConflicts">Ignore Conflicts</md-checkbox>
              <md-checkbox v-model="dialogActivity.flagForReview">Needs Review</md-checkbox>
            </md-tab>

            <md-tab md-label="Details">
              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>Start</label>
                    <md-input v-model="dialogActivity.start" type="datetime-local"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label>End</label>
                    <md-input v-model="dialogActivity.end" type="datetime-local"></md-input>
                  </md-field>
                </div>
              </div>

              <md-field>
                <label>Course Activity</label>
                <md-select v-model="dialogActivity.courseActivityId" md-dense>
                  <md-option value="">None</md-option>
                  <md-optgroup v-for="course in getCourses(dialogActivity.sectionIds)" :key="course.versionedId.id" :label="course.name">
                    <md-option v-for="activity in course.activities" :key="activity.versionedId.id" :value="activity.versionedId.id">{{activity.name}}</md-option>
                    <md-option :value="'CREATENEWCOURSEACTIVITY_' + course.versionedId.id">Create a new activity in
                      "{{course.name}}"
                    </md-option>
                  </md-optgroup>

                </md-select>
              </md-field>
            </md-tab>

            <md-tab md-label="Notes">
              <!--<md-field>-->
              <!--<label>Staff Notes</label>-->
              <!--<md-textarea v-model="dialogActivity.staffNotes"></md-textarea>-->
              <!--</md-field>-->

              Staff Notes<br/>
              <textarea class="prettyTextarea" v-model="dialogActivity.staffNotes"></textarea>
              <br/>


              <!--<md-field>-->
              <!--<label>Student Notes</label>-->
              <!--<md-textarea v-model="dialogActivity.studentNotes"></md-textarea>-->
              <!--</md-field>-->

              Student Notes<br/>
              <textarea class="prettyTextarea" v-model="dialogActivity.studentNotes"></textarea>
              <br/>

              Feedback/Planning Notes<br/>
              <textarea class="prettyTextarea" v-model="dialogActivity.feedback"></textarea>
              <md-checkbox v-model="dialogActivity.feedbackResolved">Resolved</md-checkbox>


            </md-tab>
          </md-tabs>

          <div class="md-layout">
            <div class="md-layout-item md-layout md-alignment-bottom-space-between">
              <div>
                <md-button v-if="!dialogActivity.isNew" class="md-primary" @click="deleteActivity">Delete</md-button>
              </div>
              <div>
                <md-button class="md-primary" @click="cancelActivityDetailsDialog">Cancel</md-button>
                <md-button class="md-primary md-raised" @click="saveOrCreateActivity" v-bind:disabled="!activityDetailsDialogCreateSaveActive"><span v-if="!dialogActivity.isNew">Save</span><span v-if="dialogActivity.isNew">Create</span></md-button>
              </div>
            </div>
          </div>
        </div>
      </md-dialog>

      <md-dialog :md-active.sync="createStaffPromptActive">
        <md-dialog-title>Create a new Staff</md-dialog-title>

        <div class="dialogContent">
          <md-field>
            <label>Name</label>
            <md-input ref="newStaffFirstField" v-model="newStaff.name" @keyup.enter="createStaff" @keyup.esc="createStaffPromptActive = false" maxlength="255"></md-input>
          </md-field>
          <md-field >
            <label>Initials</label>
            <md-input v-model="newStaff.initials" @keyup.enter="createStaff" @keyup.esc="createStaffPromptActive = false" maxlength="255"></md-input>
          </md-field>
          <md-field>
            <swatches v-model="newStaff.color" :colors="colors" :exceptions="otherColors(null)" inline show-border></swatches>
          </md-field>

          <md-dialog-actions>
            <md-button class="md-primary" @click="createStaffPromptActive = false">Cancel</md-button>
            <md-button class="md-primary md-raised" @click="createStaff" v-bind:disabled="!dialogCreateStaffActive">Create</md-button>
          </md-dialog-actions>
        </div>
      </md-dialog>

    </div>
  </div>
</template>

<script>
  // https://github.com/CroudSupport/vue-fullcalendar
  // https://fullcalendar.io/docs/
  import {FullCalendar} from 'vue-full-calendar'
  import $ from 'jquery'
  import moment from 'moment'
  import Swatches from 'vue-swatches'

  var activityNameCompareIgnoreCase = function(a, b) {
    var nameA = a.activity.name.toUpperCase(); // ignore upper and lowercase
    var nameB = b.activity.name.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  };
  var courseNameCompareIgnoreCase = function(a, b) {
    var nameA = a.courseName.toUpperCase(); // ignore upper and lowercase
    var nameB = b.courseName.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  };

  function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function daysBetweenDates(start, end) {
    return 1 + Math.round((new Date(end) - new Date(start)) / 86400000);
  }

  function extractDateTime(moment) {
    return moment.format().replace("Z", "");
  };

  export default {
    components: {
      FullCalendar,
      Swatches
    },
    name: "weekend-edit",
    data () {
      return {
        weekendSubscriptionId: null,
        weekend: null,
        weekendFromServer: null,
        activityDetailsDialogActive: false,
        sectionDetailsDialogActive: false,
        weekendDetailsDialogActive: false,
        deleteWeekendPromptActive: false,
        dialogActivity: {
          newStaffId: 'addstaff',
          conflicts: []
        },
        dialogSection: {
          staffIds: {},
          newStaffId: {}
        },
        dialogWeekend: {
          newSections: []
        },
        currentView: 'weekend',
        currentViewTitle: '',
        currentViewDate: null,
        slotDurationIndex: 2,
        slotDuration: '00:30:00',
        snapDuration: '00:15:00',
        createStaffPromptActive: false,
        newStaff: {
          name: '',
          initials: '',
          color: ''
        },
        selectedStaffForFilter: [],
        selectedLocationsForFilter: [],
        showMissingCourseActivities: true,
        deleteSectionPromptActive: false,
        sectionToDelete: {},
        linksDialogActive: false,
        activityRevertCommand: null,
        colors: [
          'DEFAULT',
          '#D32F2F',
          '#C2185B',
          '#7B1FA2',
          '#512DA8',
          '#303F9F',
          '#1976D2',
          '#0288D1',
          '#0097A7',
          '#00796B',
          '#388E3C',
          '#689F38',
          '#AFB42B',
          '#FBC02D',
          '#FFA000',
          '#F57C00',
          '#E64A19',
          '#5D4037',
          '#616161',
          '#455A64'
        ],
        staffLabels: [
          {label: 'Teach', icon: 'label_important'},
          {label: 'Lead', icon: 'label_important'},
          {label: 'Observe', icon: 'label'},
          {label: 'Assist', icon: 'label'},
          {label: 'Serve', icon: 'label_important'},
          {label: 'Eat', icon: 'label'}
        ],
        deleteKeyPressed: false,
        staffToDelete: {},
        deleteStaffPromptActive: false
      }
    },
    computed: {
      calendarConfig() {
        var vue = this;
        if (!this.weekend) {
          return {};
        }

        var resources = [];
        this.weekend.sections.forEach(section => {
            var course = null;
            this.courses.forEach(c => {
              if (section.courseId && section.courseId.id === c.versionedId.id)
                course = c;
            });
            var color = null;
            if (course && course.color && this.weekend.courseIds.length > 1)
              color = course.color;
          resources.push(
            {
              id: section.versionedId.id,
              title: section.name,
              name: section.name,
              maxStudents: section.maxStudents,
              currentStudents: section.currentStudents,
              titleBackgroundColor: color
            });
          }
        );

        var days = daysBetweenDates(this.weekend.start, this.weekend.end);

        return {
          header: false,
          viewRender: this.updateView,
          validRange: {
            start: this.weekend.start,
            end: addDays(this.weekend.end, 1)
          },
          defaultDate: this.currentViewDate ? this.currentViewDate : this.weekend.start,
          defaultView: this.currentView,
          minTime: this.weekend.dailyStart,
          maxTime: this.weekend.dailyEnd,
          views: {
            agendaDay: {
              slotDuration: this.slotDuration,
              displayEventTime: false
            },
            weekend: {
              type: 'agenda',
              duration: {
                days: days
              },
              buttonText: 'weekend',
              allDaySlot: true,
              navLinks: true,
              navLinkDayClick: this.switchToDayView,
              groupByResource: true,
              groupByDateAndResource: true,
              slotDuration: this.slotDuration
            }
          },
          resourceLabelText: 'Section',
          resources: resources,
          resourceColumns: [
            {
              labelText: 'Name',
              field: 'name'
            },
            {
              labelText: 'Current Students',
              field: 'currentStudents'
            },
            {
              labelText: 'Max Students',
              field: 'maxStudents'
            }
          ],
          // eventColor: '#455A64',
          eventColor: '#00796B',
          eventTextColor: '#FFFFFF',
          displayEventTime: false,
          height: "auto",
          timezone: "UTC",
          allDayText: "",
          droppable: true,
          slotDuration: this.slotDuration,
          snapDuration: this.snapDuration,
          eventReceive: this.createActivityFromExternalDrop,
          eventRender: function(event, element) {
            var title = element.find(".fc-title")[0];
            if (title) {
              var newInnerHTML = "<div class='md-layout md-alignment-top-space-between' style='display: flex;'>";

              newInnerHTML += "<span>" + (event.title || '&nbsp') + "</span>";

              if (event.titleCenter)
                newInnerHTML += "<span>" + event.titleCenter + "</span>";

              if (event.titleRight)
                newInnerHTML += "<span>" + event.titleRight + "</span>";

              newInnerHTML += "</div>";

              if (event.description && event.description.length > 0)
                newInnerHTML += "<div>" + event.description + "</div>";

              if (event.staffNotes && event.staffNotes.length > 0)
                newInnerHTML += "<div>Staff notes: " + event.staffNotes + "</div>";

              if (event.studentNotes && event.studentNotes.length > 0)
                newInnerHTML += "<div>Student notes: " + event.studentNotes + "</div>";

              if (!event.feedbackResolved && event.feedback && event.feedback.length > 0)
                newInnerHTML += "<div>Planning notes: " + event.feedback + "</div>";

              title.innerHTML = newInnerHTML;
              title.style.display = 'block';
            }

            var content = element.find(".fc-content");
            var bottomRight = "<div class='eventIconHolder'>";
            if (content && event.flagForReview)
              bottomRight += "<i class='material-icons eventIcon'>flag</i>";
            else if (content && event.hasConflicts)
              bottomRight += "<i class='material-icons eventIcon'>warning</i>";
            else if (event.isSoftLocked)
              bottomRight += "<i class='material-icons eventIcon'>lock</i>";

            if (event.hasFeedback)
              bottomRight += "<i class='material-icons eventIcon'>mode_comment</i>";
            bottomRight += "</div>";
            content.append(bottomRight);
          },
          resourceRender: function (resourceObj, labelTds, bodyTds) {
            if (resourceObj.titleBackgroundColor) {
              labelTds.css('background', resourceObj.titleBackgroundColor);
              labelTds.css('color', 'white');
            }
            labelTds.css('cursor', 'pointer');
            labelTds.on('click', () => vue.editSection(resourceObj.id, null, "details"))
          },
          schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives'
        }
      },
      calendarEvents() {
        if (!this.weekend.activities || !this.locationList) {
          return [];
        }

        var startTime = performance.now();

        var sectionLengthInMinutes = {};
        this.weekend.sections.forEach(section => {
          sectionLengthInMinutes[section.versionedId.id] = 0;
        });
        var events = [];

        this.weekend.activities.forEach(activity => {
          var locationString = activity.location ? activity.location.abbreviation : null;

          var staff = [];
            activity.staffAssignments.forEach(staffAssignment => {
              this.staffList.forEach(staffObject => {
                if (staffObject.versionedId.id === staffAssignment.staffId.id) {
                  staff.push(staffObject);
                }
              });
            });

          var staffInitials = [];
          staff.forEach(staffObject => staffInitials.push(staffObject.initials));

          var staffString = null;
          if (staffInitials.length > 0) {
            staffString = staffInitials.join(", ");
          }

          var sectionIds = [];
          activity.sections.forEach(section => sectionIds.push(section.versionedId.id));

          var title = activity.name;

          var event = {
            id: activity.versionedId.id,
            title: title,
            titleCenter: locationString,
            titleRight: staffString,
            description: activity.description && activity.description.length > 0 ? activity.description : null,
            staffNotes: activity.staffNotes,
            studentNotes: activity.studentNotes,
            start: activity.start,
            end: activity.end,
            resourceIds: sectionIds,
            flagForReview: activity.flagForReview,
            hasConflicts: activity.conflicts.length > 0 && !activity.ignoreConflicts,
            isSoftLocked: this.$store.state.otherUserPageLocks[activity.versionedId.id],
            hasFeedback: !activity.feedbackResolved && activity.feedback && activity.feedback.length > 0,
            feedback: activity.feedback,
            feedbackResolved: activity.feedbackResolved
          };

          if (staff.length > 0 && staff[0].color && staff[0].color !== 'DEFAULT') {
            event.backgroundColor = staff[0].color;
            event.borderColor = staff[0].color;
          } else if (activity.allStaff) {
            event.backgroundColor = '#C2185B';
            event.borderColor = '#C2185B';
          }

          if (activity.conflicts.length > 0 && !activity.ignoreConflicts)
            event.className = 'eventError';

          if (activity.flagForReview)
            event.className = 'eventWarning';

          var includesFilteredStaff = false;
          staff.forEach(staffObject => {
            if (this.selectedStaffForFilter.includes(staffObject.versionedId.id))
              includesFilteredStaff = true;
          });
          if (activity.allStaff)
            includesFilteredStaff = true;

          var lengthInMinutes = moment(event.end).diff(moment(event.start), 'minutes');
          sectionIds.forEach(sectionId => {
            sectionLengthInMinutes[sectionId] += lengthInMinutes;
          });

          if ((this.selectedStaffForFilter.length === 0 || includesFilteredStaff) &&
            (this.selectedLocationsForFilter.length === 0 || (activity.location && this.selectedLocationsForFilter.includes(activity.location.versionedId.id))))
            events.push(event)
        });

        this.weekend.sections.forEach(section => {
          var studentRatio = section.maxStudents !== 0 || section.currentStudents !== 0 ? "" + section.currentStudents + "/" + section.maxStudents : "";
          var lengthInMinutes = sectionLengthInMinutes[section.versionedId.id];
          var sectionLength = lengthInMinutes >= 60 || lengthInMinutes === 0 ? (Math.round(1 * lengthInMinutes / 60) / 1) + 'h' : lengthInMinutes + 'm';

          this.weekendDays.forEach(day => {
            var staffString = null;
            var staff = [];

            if (section.staffIds[day]) {
              section.staffIds[day].forEach(staffId => {
                this.staffList.forEach(staffObject => {
                  if (staffObject.versionedId.id === staffId.id) {
                    staff.push(staffObject);
                  }
                });
              });

              var staffInitials = [];
              staff.forEach(staffObject => staffInitials.push(staffObject.initials));

              if (staffInitials.length > 0) {
                staffString = staffInitials.join(", ");
              }
            }

            var event = {
              title: staffString,
              titleCenter: sectionLength,
              titleRight: studentRatio,
              start: day,
              resourceId: section.versionedId.id,
              allDay: true,
              editable: false
            };

            if (staff.length > 0) {
              event.backgroundColor = staff[0].color;
              event.borderColor = staff[0].color;
            }
            if (!section.isStaffOnlySection)
              events.push(event);
          });
        });

        var endTime = performance.now();
        console.log("Computing calendar events - " + Math.ceil(endTime - startTime) + "ms.")

        return events;
      },
      activityDetailsDialogCreateSaveActive() {
        return this.dialogActivity.name && this.dialogActivity.name.length > 0 && this.dialogActivity.sectionIds && this.dialogActivity.sectionIds.length > 0;
      },
      sectionDetailsDialogCreateSaveActive() {
        return this.dialogSection.name && this.dialogSection.name.length > 0;
      },
      weekendDetailsDialogCreateSaveActive() {
        return this.dialogWeekend.name && this.dialogWeekend.name.length > 0;
      },
      locationList() {
        if (this.$store.state.currentCityDetails.rooms && this.$store.state.currentCityDetails.vehicles) {
          var locations = [];
          this.$store.state.currentCityDetails.rooms.forEach(location => locations.push(location));
          this.$store.state.currentCityDetails.vehicles.forEach(location => locations.push(location));
          return locations;
        } else {
          return [];
        }
      },
      staffList() {
        if (this.$store.state.currentCityDetails.staff) {
          var staff = [];
          this.$store.state.currentCityDetails.staff.forEach(staffMember => {
            staffMember.visibleName = staffMember.name + " (" + staffMember.initials + ")";
            staff.push(staffMember);
          });
          return staff;
        } else {
          return [];
        }
      },
      enabledStaffList() {
        if (this.$store.state.currentCityDetails.staff) {
          var staff = [];
          this.$store.state.currentCityDetails.staff.forEach(staffMember => {
            staffMember.visibleName = staffMember.name + " (" + staffMember.initials + ")";
            if (staffMember.enabled)
              staff.push(staffMember);
          });
          return staff;
        } else {
          return [];
        }
      },
      weekendDays() {
        if (!this.weekend.start) {
          return [];
        }

        var days = [];

        var date = moment(this.weekend.start);
        var endDate = moment(this.weekend.end);
        while (date <= endDate) {
          days.push(date.format("YYYY-MM-DD"));
          date = date.add(1, 'days');
        }

        return days;
      },
      courses() {
        if (this.$store.state.currentCityDetails && this.$store.state.currentCityDetails.courses) {
          return this.$store.state.currentCityDetails.courses;
        } else {
          return null;
        }
      },
      unsatisifiedCourseActivities() {
        if (this.$store.state.currentCityDetails && this.$store.state.currentCityDetails.courses && this.weekend && this.weekend.courseIds) {
          var startTime = performance.now();

          var toReturn = [];

          var courses = [];
          this.weekend.courseIds.forEach(weekendCourseId => {
            this.$store.state.currentCityDetails.courses.forEach(course => {
              if (course.versionedId.id === weekendCourseId.id)
                courses.push(course);
            });
          });

          courses.forEach(course => {
            var sectionIds = [];
            this.weekend.sections.forEach(section => {
              if (section.courseId && section.courseId.id === course.versionedId.id && !sectionIds.includes(section.versionedId.id))
                sectionIds.push(section.versionedId.id);
            });
            var activities = [];

            course.activities.forEach(templateActivity => {
              var sectionIdsMissingTemplateActivity = sectionIds.slice(); // Clone

              this.weekend.activities.forEach(activity => {
                if (activity.courseActivityId && activity.courseActivityId.id === templateActivity.versionedId.id) {
                  activity.sectionIds.forEach(idWrapper => {
                    var id = idWrapper.id;

                    for (var i = sectionIdsMissingTemplateActivity.length - 1; i >= 0; i--) {
                      if (sectionIdsMissingTemplateActivity[i] === id) {
                        sectionIdsMissingTemplateActivity.splice(i, 1);
                        break;
                      }
                    }
                  });
                }
              });

              var sectionsMissingTemplateActivity = [];
              sectionIdsMissingTemplateActivity.forEach(sectionId => {
                this.weekend.sections.forEach(section => {
                  if (section.versionedId.id === sectionId)
                    sectionsMissingTemplateActivity.push(section);
                });
              });

              if (sectionsMissingTemplateActivity.length > 0)
                activities.push({
                  activity: templateActivity,
                  sections: sectionsMissingTemplateActivity
                });
            });

            if (activities.length > 0)
              toReturn.push({
                courseId: course.versionedId.id,
                courseName: course.name,
                color: course.color || '#00796b',
                activities: activities.sort(activityNameCompareIgnoreCase)
              });
          });

          toReturn.sort(courseNameCompareIgnoreCase);

          this.$nextTick(() => {
            $('.draggable').draggable({
              zIndex: 999,
              revert: true,
              revertDuration: 0
            });
          });

          var endTime = performance.now();
          console.log("unsatisifiedCourseActivities - " + Math.ceil(endTime - startTime) + "ms.")

          return toReturn;
        } else {
          // return [];
        }
      },
      dialogCreateStaffActive() {
        return this.newStaff.name.length > 0 && this.newStaff.initials.length > 0 && this.newStaff.color.length > 0;
      },
      routeWeekendId() {
        return this.$route.params.weekendId;
      },
      usedStaffList() {
        if (!this.weekend.activities) {
          return [];
        }

        var objectIds = [];
        this.weekend.activities.forEach(activity => {
            activity.staffAssignments.forEach(staffAssignment => {
              if (!objectIds.includes(staffAssignment.staffId.id))
                objectIds.push(staffAssignment.staffId.id);
            });
        });

        var objects = [];
        objectIds.forEach(id => {
          this.staffList.forEach(staffObject => {
            if (staffObject.versionedId.id === id)
              objects.push(staffObject);
          });
        });

        var invalid = false;
        this.selectedStaffForFilter.forEach(filteredId => {
          if (!objectIds.includes(filteredId))
            invalid = true;
        });
        if (invalid)
          this.selectedStaffForFilter = [];

        return objects;
      },
      usedLocationList() {
        if (!this.weekend.activities) {
          return [];
        }

        var objectIds = [];
        this.weekend.activities.forEach(activity => {
          if (activity.locationId && !objectIds.includes(activity.locationId.id))
            objectIds.push(activity.locationId.id);
        });

        var objects = [];
        objectIds.forEach(id => {
          this.locationList.forEach(location => {
            if (location.versionedId.id === id)
              objects.push(location);
          });
        });

        var invalid = false;
        this.selectedLocationsForFilter.forEach(filteredId => {
          if (!objectIds.includes(filteredId))
            invalid = true;
        });
        if (invalid)
          this.selectedLocationsForFilter = [];

        return objects;
      }
    },
    methods: {
      weekendChangeHandler(newWeekend) {
        if (!newWeekend)
          return;

        this.weekendFromServer = newWeekend;

        newWeekend.activities.forEach(activity => {
          var sections = [];
          activity.sectionIds.forEach(sectionId => {
            newWeekend.sections.forEach(sectionObject => {
              if (sectionObject.versionedId.id === sectionId.id) {
                sections.push(sectionObject);
              }
            });
          });
          var studentCount = 0;
          sections.forEach(section => {
            studentCount += section.maxStudents;
          });

          activity.sections = sections;

          var location = null;
          this.locationList.forEach(locationObject => {
            if (activity.locationId && locationObject.versionedId.id === activity.locationId.id) {
              location = locationObject;
            }
          });

          activity.location = location;

          var conflicts = [];
          if (activity.conflicts)
            Object.keys(activity.conflicts).forEach(title => {
              conflicts.push({
                title: title,
                description: activity.conflicts[title]
              })
            });

          if (location && studentCount > location.capacity)
            conflicts.push({
              title: 'Location Capacity',
              description: "" + studentCount + " students are scheduled in a location with a capacity of " + location.capacity + "."
            });
          activity.conflicts = conflicts;
        });

        newWeekend.sections.forEach(section => {
          if (section.name && section.name.toLowerCase().includes("staff"))
            section.isStaffOnlySection = true;
        });

        if (this.weekend && this.weekend.dailyStart && this.weekend.dailyEnd && newWeekend && newWeekend.dailyStart && newWeekend.dailyStart &&
          (this.weekend.dailyStart !== newWeekend.dailyStart || this.weekend.dailyEnd !== newWeekend.dailyEnd)) {
          this.$refs.calendar.fireMethod('option', {
            minTime: newWeekend.dailyStart,
            maxTime: newWeekend.dailyEnd
          });
        }

        var unsafeChange = this.weekend && this.weekend.start && this.weekend.end && (this.weekend.start !== newWeekend.start || this.weekend.end !== newWeekend.end);
        if (this.weekend && this.weekend.sections && newWeekend && newWeekend.sections) {
          this.weekend.sections.forEach(oldSection => {
            newWeekend.sections.forEach(newSection => {
              if (oldSection.versionedId.id === newSection.versionedId.id && oldSection.name !== newSection.name)
                unsafeChange = true;
            });
          });
        }

        if (this.weekend && this.weekend.sections && newWeekend && newWeekend.sections && this.weekend.sections.length !== newWeekend.sections.length) {
          unsafeChange = true;
        }

        if (unsafeChange) {
          this.weekend = null;
          this.$nextTick(function() {
            this.weekend = newWeekend;
          });
        } else {
          this.weekend = newWeekend;
        }
      },
      editSection(resourceId, start, tab) {
        var section = null;
        this.weekend.sections.forEach(sectionObject => {
          if (sectionObject.versionedId.id === resourceId) {
            section = sectionObject;
          }
        });

        var staffIds = {};
        if (section.staffIds)
          Object.keys(section.staffIds).forEach(date => {
            staffIds[date] = [];
            section.staffIds[date].forEach(id => staffIds[date].push(id.id));
          });

        this.dialogSection = {
          versionedId: section.versionedId,
          name: section.name,
          maxStudents: section.maxStudents,
          currentStudents: section.currentStudents,
          staffNotes: section.staffNotes,
          studentNotes: section.studentNotes,
          staffIds: staffIds,
          newStaffId: {},
          courseId: section.courseId ? section.courseId.id : '',
          tab: tab
        };

        if (section) {
          this.sectionDetailsDialogActive = true;
        }
      },
      createEventFromSelect(calEvent) {
        if (this.deleteKeyPressed) {
          this.$refs.calendar.fireMethod('unselect');
          return;
        }

        if (calEvent.allDay) {
          this.editSection(calEvent.resource.id, calEvent.start, "staff");
          return;
        }

        var staffAssignments = [];
        this.selectedStaffForFilter.forEach(staffId => staffAssignments.push({
          staffId: staffId,
          label: null,
          menu: false
        }))

        this.dialogActivity = {
          isNew: true,
          sourceEvent: calEvent,
          name: '',
          start: extractDateTime(calEvent.start),
          end: extractDateTime(calEvent.end),
          sectionIds: [],
          locationId: this.selectedLocationsForFilter.length > 0 ? this.selectedLocationsForFilter[0] : '',
          staffAssignments: staffAssignments,
          courseActivityId: '',
          flagForReview: false,
          allStaff: false,
          color: '',
          ignoreConflicts: false,
          newStaffId: 'addstaff',
          feedback: '',
          feedbackResolved: false
        };

        if (calEvent.resource) {
          this.dialogActivity.sectionIds.push(calEvent.resource.id);
        }

        this.activityDetailsDialogActive = true;
        var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.activityDetailsDialogFirstField.$el.focus()), 300);
      },
      cancelActivityDetailsDialog() {
        this.$refs.calendar.fireMethod('unselect');
        this.activityDetailsDialogActive = false;
        if (this.dialogActivity.versionedId)
          this.$store.api.softUnlock(this.$route.fullPath, this.dialogActivity.versionedId.id);
      },
      editEventFromSelect(calEvent) {
        if (calEvent.allDay) {
          this.editSection(calEvent.resourceId, calEvent.start, "staff");
          return;
        }

        var activity = null;
        this.weekend.activities.forEach(a => {
          if (a.versionedId.id === calEvent.id) {
            activity = a;
          }
        });

        var sectionIds = [];
        activity.sectionIds.forEach(id => sectionIds.push(id.id));

        var staffAssignments = [];
          activity.staffAssignments.forEach(staffAssignment => staffAssignments.push({
            staffId: staffAssignment.staffId.id,
            label: staffAssignment.label,
            menu: false
          }));

        if (activity) {
          this.dialogActivity = {
            sourceEvent: null,
            versionedId: activity.versionedId,
            name: activity.name,
            start: activity.start,
            end: activity.end,
            description: activity.description,
            sectionIds: sectionIds,
            locationId: activity.locationId ? activity.locationId.id : null,
            staffAssignments: staffAssignments,
            courseActivityId: activity.courseActivityId ? activity.courseActivityId.id : null,
            staffNotes: activity.staffNotes,
            studentNotes: activity.studentNotes,
            flagForReview: activity.flagForReview,
            allStaff: activity.allStaff,
            color: activity.color,
            conflicts: activity.conflicts,
            ignoreConflicts: activity.ignoreConflicts,
            feedback: activity.feedback,
            feedbackResolved: activity.feedbackResolved
          };

          if (this.deleteKeyPressed) {
            this.deleteActivity();
            return;
          }

          this.activityDetailsDialogActive = true;

          var vue = this;
          setTimeout(() => vue.$store.api.softLock(this.$route.fullPath, activity.versionedId.id), 0)

          var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.activityDetailsDialogFirstField.$el.focus()), 300);
        }
      },
      createActivityFromExternalDrop(calEvent) {
        var sections = calEvent.resourceIds;
        if (!sections)
          sections = [];
        sections.push(calEvent.resourceId);

        this.activityRevertCommand = null;

        var staffAssignments = [];
        this.selectedStaffForFilter.forEach(staffId => staffAssignments.push({staffId: staffId, label: null}))

        this.$store.api.rpcRequest('createActivity', {
          weekendId: this.weekend.versionedId.id,
          name: calEvent.title,
          start: extractDateTime(calEvent.start),
          end: extractDateTime(calEvent.end),
          sectionIds: sections,
          locationId: this.selectedLocationsForFilter.length > 0 ? this.selectedLocationsForFilter[0] : '',
          staffAssignments: staffAssignments,
          description: calEvent.description || '',
          courseActivityId: calEvent.courseActivityId,
          staffNotes: '',
          studentNotes: '',
          flagForReview: false,
          allStaff: false,
          color: '',
          feedback: '',
          feedbackResolved: false
        }, newObject => {
          this.$refs.calendar.fireMethod('removeEvents', calEvent._id);
        }, errorMessage => {
          this.$refs.calendar.fireMethod('removeEvents', calEvent._id);
        });
      },
      saveOrCreateActivity() {
        if (!this.activityDetailsDialogCreateSaveActive)
          return;

        this.activityRevertCommand = null;

        if (this.dialogActivity.isNew) {
          this.cancelActivityDetailsDialog();

          this.$store.api.rpcRequest('createActivity', {
            weekendId: this.weekend.versionedId.id,
            name: this.dialogActivity.name,
            start: this.dialogActivity.start,
            end: this.dialogActivity.end,
            sectionIds: this.dialogActivity.sectionIds,
            locationId: this.dialogActivity.locationId || '',
            staffAssignments: this.dialogActivity.staffAssignments,
            description: this.dialogActivity.description || '',
            courseActivityId: this.dialogActivity.courseActivityId || '',
            staffNotes: this.dialogActivity.staffNotes || '',
            studentNotes: this.dialogActivity.studentNotes || '',
            flagForReview: this.dialogActivity.flagForReview,
            allStaff: this.dialogActivity.allStaff,
            color: this.dialogActivity.color,
            feedback: this.dialogActivity.feedback,
            feedbackResolved: this.dialogActivity.feedbackResolved

          }, newObject => {
          }, errorMessage => {
            this.activityDetailsDialogActive = true;
          });
        } else {
          this.cancelActivityDetailsDialog();

          this.$store.api.rpcRequest('saveActivity', {
            versionedId: this.dialogActivity.versionedId,
            name: this.dialogActivity.name,
            start: this.dialogActivity.start,
            end: this.dialogActivity.end,
            sectionIds: this.dialogActivity.sectionIds,
            locationId: this.dialogActivity.locationId || '',
            staffAssignments: this.dialogActivity.staffAssignments,
            description: this.dialogActivity.description || '',
            courseActivityId: this.dialogActivity.courseActivityId || '',
            staffNotes: this.dialogActivity.staffNotes || '',
            studentNotes: this.dialogActivity.studentNotes || '',
            flagForReview: this.dialogActivity.flagForReview,
            allStaff: this.dialogActivity.allStaff,
            color: this.dialogActivity.color || '',
            ignoreConflicts: this.dialogActivity.ignoreConflicts,
            feedback: this.dialogActivity.feedback,
            feedbackResolved: this.dialogActivity.feedbackResolved
          }, response => {
            var sectionIds = [];
            response.oldActivity.sectionIds.forEach(id => sectionIds.push(id.id));

            var staffAssignments = [];
            response.oldActivity.staffAssignments.forEach(assignment => staffAssignments.push({
              staffId: assignment.staffId.id,
              label: assignment.label
            }));
            this.activityRevertCommand = {
              method: "saveActivity",
              parameters: {
                versionedId: response.newActivity.versionedId,
                name: response.oldActivity.name,
                start: response.oldActivity.start,
                end: response.oldActivity.end,
                sectionIds: sectionIds,
                locationId: response.oldActivity.locationId ? response.oldActivity.locationId.id : '',
                staffAssignments: staffAssignments,
                description: response.oldActivity.description,
                courseActivityId: response.oldActivity.courseActivityId ? response.oldActivity.courseActivityId.id : '',
                staffNotes: response.oldActivity.staffNotes,
                studentNotes: response.oldActivity.studentNotes,
                flagForReview: response.oldActivity.flagForReview,
                allStaff: response.oldActivity.allStaff,
                color: response.oldActivity.color || '',
                ignoreConflicts: response.oldActivity.ignoreConflicts,
                feedback: response.oldActivity.feedback,
                feedbackResolved: response.oldActivity.feedbackResolved
              }
            };
          }, errorMessage => {
            this.activityDetailsDialogActive = true;
            this.$store.api.softLock(this.$route.fullPath, this.dialogActivity.versionedId.id);
          });
        }
      },
      deleteActivity() {
        this.cancelActivityDetailsDialog();
        this.$store.api.rpcRequest('deleteActivity', {
          versionedId: this.dialogActivity.versionedId,
          deleted: true
        }, newObject => {
          this.activityRevertCommand = {
            method: "deleteActivity",
            parameters: {
              versionedId: newObject.versionedId,
              deleted: false
            }
          };
        }, errorMessage => {
          this.activityDetailsDialogActive = true;
        });
      },
      deleteStaffIdFromDialog(array, staffId) {
        if (!array)
          array = [];
        var index = array.indexOf(staffId);
        if (index > -1) {
          array.splice(index, 1);
        }
      },
      setPrimaryStaffIdFromDialog(array, staffId) {
        var index = array.indexOf(staffId);
        if (index > -1) {
          array.splice(index, 1);
          array.unshift(staffId);
        }
      },
      addStaffIdFromDialog(arrayHolder, arrayName, newStaffIdHolder, newStaffIdName) {
        if (!arrayHolder || !newStaffIdHolder[newStaffIdName])
          return;

        if (!arrayHolder[arrayName])
          arrayHolder[arrayName] = [];

        var index = arrayHolder[arrayName].indexOf(newStaffIdHolder[newStaffIdName].versionedId.id);
        if (index === -1)
          arrayHolder[arrayName].push(newStaffIdHolder[newStaffIdName].versionedId.id);
        newStaffIdHolder[newStaffIdName] = null;
        this.$nextTick(() => {
          newStaffIdHolder[newStaffIdName] = '';
        });
      },
      addStaffIdToActivityFromDialog(arrayHolder, arrayName, newStaffIdHolder, newStaffIdName) {
        if (!arrayHolder || !newStaffIdHolder[newStaffIdName] || newStaffIdHolder[newStaffIdName] === 'addstaff')
          return;

        if (!arrayHolder[arrayName])
          arrayHolder[arrayName] = [];

        var found = false;
        arrayHolder[arrayName].forEach(assignment => {
          if (assignment.staffId === newStaffIdHolder[newStaffIdName].versionedId.id)
            found = true;
        });

        if (!found)
          arrayHolder[arrayName].push({
            staffId: newStaffIdHolder[newStaffIdName].versionedId.id,
            label: null,
            menu: false
          });

        newStaffIdHolder[newStaffIdName] = 'addstaff';
        this.$nextTick(() => {
          newStaffIdHolder[newStaffIdName] = 'addstaff';
        });
      },
      getStaffCardString(staffId) {
        var staffString = '';
        if (this.$store.state.currentCityDetails.staff) {
          this.$store.state.currentCityDetails.staff.forEach(staffMember => {
            if (staffMember.versionedId.id === staffId)
              staffString = staffMember.initials;
          })
        }
        return staffString;
      },
      getStaffNameString(staffId) {
        var staffString = '';
        if (this.$store.state.currentCityDetails.staff) {
          this.$store.state.currentCityDetails.staff.forEach(staffMember => {
            if (staffMember.versionedId.id === staffId)
              staffString = staffMember.name;
          })
        }
        return staffString;
      },
      moveEventFromSelect(event, delta, revertFunc) {
        var sectionIds = event.resourceIds;
        if (!sectionIds) {
          sectionIds = [];
        }
        if (event.resourceId) {
          sectionIds.push(event.resourceId);
        }

        this.$store.api.rpcRequest('moveActivity', {
          activityId: event.id,
          start: extractDateTime(event.start),
          end: extractDateTime(event.end),
          sectionIds: sectionIds
        }, response => {
          var sectionIds = [];
          response.oldActivity.sectionIds.forEach(id => sectionIds.push(id.id));
          this.activityRevertCommand = {
            method: "moveActivity",
            parameters: {
              activityId: response.newActivity.versionedId.id,
              start: response.oldActivity.start,
              end: response.oldActivity.end,
              sectionIds: sectionIds
            }
          };
        }, errorMessage => {
          revertFunc();
        });
      },
      revertActivity() {
        if (this.activityRevertCommand === null)
          return;

        this.$store.api.rpcRequest(this.activityRevertCommand.method, this.activityRevertCommand.parameters, response => {
          this.activityRevertCommand = null;
        }, errorMessage => {
        });
      },
      saveSection() {
        this.sectionDetailsDialogActive = false;

        this.$store.api.rpcRequest('saveSection', {
          versionedId: this.dialogSection.versionedId,
          name: this.dialogSection.name,
          maxStudents: this.dialogSection.maxStudents,
          currentStudents: this.dialogSection.currentStudents,
          staffNotes: this.dialogSection.staffNotes,
          studentNotes: this.dialogSection.studentNotes,
          staffIds: this.dialogSection.staffIds,
          courseId: this.dialogSection.courseId || ''
        }, newObject => {
        }, errorMessage => {
          this.sectionDetailsDialogActive = true;
        });
      },
      updateView(view) {
        this.currentView = view.name;
        this.currentViewTitle = view.title;
        this.currentViewDate = view.start.format("YYYY-MM-DD");

        this.saveEditorSettings();
      },
      switchToDayView(date) {
        this.$refs.calendar.fireMethod('changeView', 'agendaDay', date);
      },
      editWeekend() {
        this.dialogWeekend = {
          versionedId: this.weekend.versionedId,
          name: this.weekend.name,
          start: this.weekend.start,
          oldStart: this.weekend.start,
          end: this.weekend.end,
          oldEnd: this.weekend.end,
          staffNotes: this.weekend.staffNotes,
          studentNotes: this.weekend.studentNotes,
          dailyStart: this.weekend.dailyStart,
          dailyEnd: this.weekend.dailyEnd,
          newSections: []
          // courseId: this.weekend.courseId ? this.weekend.courseId.id : null
        };
        this.weekendDetailsDialogActive = true;

        var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.weekendDetailsDialogFirstField.$el.focus()), 300);
      },
      weekendDetailsDialogStartDateFilter(day) {
        if (!this.dialogWeekend.end) {
          return false;
        }
        return day > this.dialogWeekend.end;
      },
      weekendDetailsDialogEndDateFilter(day) {
        if (!this.dialogWeekend.end) {
          return false;
        }
        return day < this.dialogWeekend.start;
      },
      saveWeekend() {
        this.weekendDetailsDialogActive = false;

        this.$store.api.rpcRequest('saveWeekend', {
          versionedId: this.dialogWeekend.versionedId,
          name: this.dialogWeekend.name,
          start: this.dialogWeekend.start,
          end: this.dialogWeekend.end,
          staffNotes: this.dialogWeekend.staffNotes,
          studentNotes: this.dialogWeekend.studentNotes,
          dailyStart: this.dialogWeekend.dailyStart,
          dailyEnd: this.dialogWeekend.dailyEnd,
          sections: this.dialogWeekend.newSections
          // courseId: this.dialogWeekend.courseId || ''
        }, newObject => {
        }, errorMessage => {
          this.weekendDetailsDialogActive = true;
        });
      },
      deleteWeekend() {
        this.$store.api.rpcRequest('deleteWeekend', {
          versionedId: this.weekend.versionedId
        }, newObject => {
          this.$router.push('../weekends');
        }, errorMessage => {
        });
      },
      getCourse(courseId) {
        var selectedCourse = {};
        this.courses.forEach(course => {
          if (course.versionedId.id === courseId)
            selectedCourse = course;
        });
        return selectedCourse;
      },
      showNewStaffDialog(term) {
        this.newStaff = {
          name: term || '',
          initials: '',
          color: 'DEFAULT'
        };
        this.createStaffPromptActive = true;
        var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.newStaffFirstField.$el.focus()), 300);
      },
      createStaff() {
        if (!this.dialogCreateStaffActive)
          return;

        this.createStaffPromptActive = false;
        this.$store.api.rpcRequest('createStaff', {
          name: this.newStaff.name,
          initials: this.newStaff.initials,
          color: this.newStaff.color,
          cityId: this.$store.state.currentCity.versionedId.id
        }, newObject => {
        }, errorMessage => {
          this.createStaffPromptActive = true;
        });
      },
      otherColors(userId) {
        var usedColors = [];
        if (this.staffList) {
          this.staffList.forEach(staff => {
            if (staff.versionedId.id !== userId && staff.color && staff.color.length > 0 && staff.color !== 'DEFAULT')
              usedColors.push(staff.color);
          })
        }
        return usedColors;
      },
      getCourses(sectionIds) {
        if (!sectionIds)
          return [];

        var courseIds = [];
        this.weekend.sections.forEach(section => {
          if (sectionIds.includes(section.versionedId.id) && section.courseId)
            courseIds.push(section.courseId.id);
        });

        var courses = [];
        this.courses.forEach(course => {
          if (courseIds.includes(course.versionedId.id))
            courses.push(course);
        });
        return courses;
      },
      deleteSection() {
        this.$store.api.rpcRequest('deleteSection', {
          versionedId: this.sectionToDelete.versionedId
        }, newObject => {
        }, errorMessage => {
          this.deleteSectionPromptActive = true;
        });
      },
      addSectionToDialogWeekend() {
        var lastSectionNumber = 0;
        this.weekend.sections.forEach(section => {
          if (section.name) {
            var numbers = section.name.match(/[0-9]+/g);
            if (numbers && numbers.length > 0)
              lastSectionNumber = Number(numbers[0]);
          }
        });

        this.dialogWeekend.newSections.forEach(section => {
          if (section.name) {
            var numbers = section.name.match(/[0-9]+/g);
            if (numbers && numbers.length > 0)
              lastSectionNumber = Number(numbers[0]);
          }
        });

        var courseId = null;
        if (this.weekend.courseIds && this.weekend.courseIds.length === 1)
          courseId = this.weekend.courseIds[0].id;

        var newSectionNUmber = lastSectionNumber + 1;
        this.dialogWeekend.newSections.push({
          name: 'S' + newSectionNUmber,
          courseId: courseId,
          currentStudents: '0'
        });
      },
      addDays(date, days) {
        var result = moment(date);
        result.add(days, 'days');
        return result.format("YYYY-MM-DD");
      },
      setSlotDuration(newDuration) {
        this.slotDurationIndex = newDuration;
        var slotOptions = ['00:10:00', '00:15:00', '00:30:00'];
        var snapOptions = ['00:05:00', '00:05:00', '00:15:00'];
        this.slotDuration = slotOptions[newDuration];
        this.snapDuration = snapOptions[newDuration];
        this.$refs.calendar.fireMethod('option', {
          slotDuration: this.slotDuration,
          snapDuration: this.snapDuration
        });
        this.saveEditorSettings();
      },
      saveEditorSettings() {
        var vue = this;
        setTimeout(function () {
          vue.$store.api.rpcRequest('saveEditorSettings', {
            slotDuration: vue.slotDuration,
            slotDurationIndex: vue.slotDurationIndex,
            snapDuration: vue.snapDuration,
            currentView: vue.currentView,
            currentViewDate: vue.currentViewDate,
            weekendId: vue.weekend.versionedId.id
          });
        }, 0);
      },
      promptToDeleteUser(staff) {
        this.staffToDelete = staff;
        this.deleteStaffPromptActive = true;
      },
      deleteStaff() {
        var index = this.selectedStaffForFilter.indexOf(this.staffToDelete.versionedId.id);
        if (index > -1)
          this.selectedStaffForFilter.splice(index, 1);

        this.activityRevertCommand = null;

        this.$store.api.rpcRequest('removeStaffFromAllActivities', {
          weekendId: this.weekend.versionedId.id,
          staffId: this.staffToDelete.versionedId.id

        }, newObject => {
        }, errorMessage => {
          this.deleteStaffPromptActive = true;
        });
      }
    },
    watch: {
      routeWeekendId(newWeekendId) {
        if (this.weekendSubscriptionId)
          this.$store.api.unsubscribe(this.weekendSubscriptionId);

        this.weekend = null;

        var vue = this;
        vue.$store.api.rpcRequest('getEditorSettings', {}, newEditorSettings => {
          if (newEditorSettings) {
            vue.slotDuration = newEditorSettings.slotDuration;
            vue.snapDuration = newEditorSettings.snapDuration;
            if (newWeekendId === newEditorSettings.weekendId) {
              vue.currentView = newEditorSettings.currentView;
              vue.currentViewDate = newEditorSettings.currentViewDate;
            }
            vue.slotDurationIndex = newEditorSettings.slotDurationIndex;
          }
          vue.weekendSubscriptionId = vue.$store.api.subscribe("WEEKEND", newWeekendId, vue.weekendChangeHandler);
        }, errorMessage => {
        });
      },
      locationList(newObject) {
        this.weekendChangeHandler(this.weekendFromServer);
      }
    },
    created() {
      var vue = this;
      vue.$store.api.rpcRequest('getEditorSettings', {}, newEditorSettings => {
        if (newEditorSettings) {
          vue.slotDuration = newEditorSettings.slotDuration;
          vue.snapDuration = newEditorSettings.snapDuration;
          if (vue.$route.params.weekendId === newEditorSettings.weekendId) {
            vue.currentView = newEditorSettings.currentView;
            vue.currentViewDate = newEditorSettings.currentViewDate;
          }
          vue.slotDurationIndex = newEditorSettings.slotDurationIndex;
        }
        vue.weekendSubscriptionId = vue.$store.api.subscribe("WEEKEND", vue.$route.params.weekendId, vue.weekendChangeHandler);
      }, errorMessage => {
      });
    },
    mounted() {
      var vue = this;
      window.addEventListener("keyup", e => {
        if (e && (e.code === "Delete" || e.code === "Backspace"))
          vue.deleteKeyPressed = false;
      });

      window.addEventListener("keydown", e => {
        if (e && (e.code === "Delete" || e.code === "Backspace"))
          vue.deleteKeyPressed = true;
      });
    },
    beforeDestroy() {
      if (this.weekendSubscriptionId)
        this.$store.api.unsubscribe(this.weekendSubscriptionId);

      this.weekendSubscriptionId = null;

      if (this.$refs.calendar)
        this.$refs.calendar.fireMethod('destroy');
    }
  }
</script>

<style scoped>
  .dialogContent {
    padding: 24px;
  }

  .md-dialog {
    z-index: 5;
    overflow: auto;
    overflow-x: hidden;
    transition: opacity 0s ease-in-out,
    transform 0s ease-in-out !important;
  }

  .draggable {
    margin: 2px;
    background-color: #00796b;
    min-width: 120px !important;
    max-width: 150px !important;
    max-height: 100px !important;
    color: #FFFFFF;
    border-radius: 3px;
    display: inline-block;
    padding: 2px;
    overflow: hidden;
  }

  .prettyTextarea {
    border-radius: 2px;
    width: 100%;
    font-family: inherit;
    display: block;
    min-height: 100px;
  }
</style>

<style>
  .eventWarning {
    border-width: 2px;
    border-color: #FFA500 !important;
  }

  .eventError {
    border-width: 2px;
    border-color: #FF0000 !important;
  }

  .fc-content {
    height: 100%;
  }

  .eventIconHolder {
    position: absolute;
    bottom:0;
    right:0;
    height: 14px;
  }

  .eventIcon {
    font-size: 14px;
  }

  .scrolledUp {
    max-height: 34px;
    overflow: hidden;
  }

  .fc-highlight {
    background: #00796b !important;
  }

  .fc-day-grid {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/city/weekend/WeekendEdit.vue